export const RADIO_INPUT_UNIQUE_ID_PREFIX = "slate-radio";
export const RADIO_GROUP_UNIQUE_NAME_PREFIX = "fs-radiogroup";
